import { CALL_STATUS } from "@/constants/call";
import { TelephonyProviderId } from "@/features/telephony/interfaces/telephony-provider.interface";
import { CallState } from "@/features/telephony/types/call-state.types";

export type TelephonyStoreState = {
    providerId: TelephonyProviderId;
    providerInitialized: boolean;
    callStatus: CallState;
    activeSessionId: string | null;
    isMuted: boolean;
    audioLevels: number[];
};

type Listener = (state: TelephonyStoreState) => void;

export class TelephonyStateStore {
    private state: TelephonyStoreState = {
        providerId: "twilio",
        providerInitialized: false,
        callStatus: CALL_STATUS.DISCONNECTED,
        activeSessionId: null,
        isMuted: false,
        audioLevels: [],
    };

    private listeners = new Set<Listener>();

    getState(): TelephonyStoreState {
        return this.state;
    }

    subscribe(listener: Listener): () => void {
        listener(this.state);
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    patch(partial: Partial<TelephonyStoreState>): void {
        this.state = { ...this.state, ...partial };
        this.listeners.forEach((listener) => listener(this.state));
    }
}
